import { useStyles } from "./GameSessionScoresStyles.css";
import AssociationLogo from "components/commons/utils/logo/AssociationLogo";
import { useIntl } from "react-intl";

const GameSessionScores = ({ pointScore, penaltyScores, position, color }) => {
    const classes = useStyles();

    const intl = useIntl();
    const penalties = Object.keys(penaltyScores).map((penalty) => (
        <div className={classes.penaltyValues}>
            {penalty === "P"
                ? `Exit/Warning: ${penaltyScores[penalty]} \u00A0  `
                : `${penalty} : ${penaltyScores[penalty]} \u00A0`}
        </div>
    ));

    return (
        <div className={classes.playerScores}>
            <div
                className={position === "left" ? classes.scoreLeft : classes.scoreRight}
            >
                <div
                    className={color === "red" ? classes.pointsRed : classes.pointsBlue}
                >
                    {pointScore}
                </div>
                <div
                    className={color === "red" ? classes.penaltyRed : classes.penaltyBlue}
                >
                    {penalties}
                </div>
            </div>
        </div>
    );
};

export default GameSessionScores;
